import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
const ServicesPage = lazy(() => import("../pages/services/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const CareersPage = lazy(() => import("../pages/careers/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/careers",
    element: <CareersPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
